/**
 * One-time WebGPU adapter probe, cached as a module-level promise.
 * Used to gate the real-time render view mode: if the browser has no WebGPU
 * or adapter negotiation fails, the mode toggle is hidden entirely.
 */

interface WebGpuSupportResult {
  supported: boolean;
  reason?: string;
}

let probePromise: Promise<WebGpuSupportResult> | null = null;

export function probeWebGpuSupport(): Promise<WebGpuSupportResult> {
  if (probePromise) return probePromise;

  probePromise = (async () => {
    if (typeof navigator === 'undefined' || !('gpu' in navigator) || !navigator.gpu) {
      return { supported: false, reason: 'navigator.gpu not available' };
    }
    try {
      const adapter = await navigator.gpu.requestAdapter({ powerPreference: 'high-performance' });
      if (!adapter) {
        return { supported: false, reason: 'No GPU adapter returned' };
      }
      return { supported: true };
    } catch (err) {
      return { supported: false, reason: err instanceof Error ? err.message : String(err) };
    }
  })();

  return probePromise;
}
